//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;


var mlsdata = require("./mls.geo.json");

var geojson;

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

function commafy( num ) {
 num = num.toString();
 if (!num) return;
 if (num.length >= 4) {
   num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
 }
 return num;
}
function highlightFeature(e) {
    var layer = e.target;

    layer.setStyle({
        weight: 4,
        color: '#666',
        fillOpacity: 0.5
    });

    if (!L.Browser.ie && !L.Browser.opera) {
        layer.bringToFront();
    }
}
function resetHighlight(e) {
    geojson.resetStyle(e.target);
}

var onEachFeature = function(feature, layer) {
    areaData[feature.properties.number].price2 = commafy(Number(areaData[feature.properties.number].price.toFixed()));
    areaData[feature.properties.number].change2 = (Number(areaData[feature.properties.number].change * 100).toFixed(0));
    // if (areaData[feature.properties.number].rel_to_peak != "NA") {
    // areaData[feature.properties.number].peak2 = (areaData[feature.properties.number].rel_to_peak * 100).toFixed(1)};
    // areaData[feature.properties.number].price_ytd2 = commafy(areaData[feature.properties.number].price_ytd);

  if (feature.properties) {
    layer.bindPopup(ich.popup(areaData[feature.properties.number]
      ))
  };
  layer.on({
    mouseover: highlightFeature,
    mouseout: resetHighlight
});
};

map.scrollWheelZoom.disable();




var getColor = function(area) {
  if (area.change >= .18) {
    return "#7a205b";
  }
  if (area.change >= .12) {
    return "#EA5455";
  }
  if (area.change >= .06) {
    return "#F07B3F";
  }
  if (area.change >= 0) {
    return "#FFD460";
  }
  if (area.change < 0) {
    return "#3988C8";
  }
  return "transparent";
}

geojson = L.geoJson(mlsdata, {
  style: function(feature) {
    if (!areaData[feature.properties.number].change) {
      return {
        fillColor: "transparent",
        weight: 1,
        opacity: 0,
        color: "white",
        fillOpacity: 0
      }
    } else if (feature.properties.number) {
      return {
        fillColor: getColor(areaData[feature.properties.number]),
        weight: 1,
        opacity: 1,
        color: "white",
        fillOpacity: 0.7
      }
    } else {
      return {
        fillColor: "gray",
        weight: 1,
        opacity: 1,
        color: "white",
        fillOpacity: 0.7
      }
    }
  },
onEachFeature: onEachFeature
}).addTo(map);

// map.fitBounds(geojson.getBounds());

var topPane = map._createPane('leaflet-top-pane', map.getPanes().mapPane);
var topLayer = L.tileLayer('http://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png').addTo(map);
topPane.appendChild(topLayer.getContainer());
topLayer.setZIndex(6);
